export default "__VITE_ASSET__y6X4ucuz__"